import { SVGProps } from "react";

const DocumentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.80859 28.3711C7.30078 28.3711 6 27.0586 6 24.5273V6.84375C6 4.32422 7.30078 3 9.80859 3H15.1641V11.8594C15.1641 13.3242 15.8672 14.0391 17.332 14.0391H26.0977V24.5273C26.0977 27.0469 24.7969 28.3711 22.2891 28.3711H9.80859ZM17.543 12.3281C17.0977 12.3281 16.8633 12.1055 16.8633 11.6602V3.11719C17.4023 3.1875 17.9297 3.58594 18.5039 4.17188L24.9141 10.6758C25.5117 11.2969 25.8984 11.8008 25.9688 12.3281H17.543ZM11.4961 19.2188H20.6367C21.1172 19.2188 21.4805 18.8555 21.4805 18.3867C21.4805 17.918 21.1172 17.5664 20.6367 17.5664H11.4961C10.9922 17.5664 10.6406 17.918 10.6406 18.3867C10.6406 18.8555 10.9922 19.2188 11.4961 19.2188ZM11.4961 23.6133H20.6367C21.1172 23.6133 21.4805 23.25 21.4805 22.793C21.4805 22.3242 21.1172 21.9609 20.6367 21.9609H11.4961C10.9922 21.9609 10.6406 22.3242 10.6406 22.793C10.6406 23.25 10.9922 23.6133 11.4961 23.6133Z"
      fill="currentColor"
    />
  </svg>
);

export default DocumentIcon;
